export default __webpack_public_path__ + "static/media/Home.4113645b.svg";